export enum WorkSelectionContext {
  Library = "library",
  Followed = "followed",
  Recommendations = "recommendations",
  List = "list",
}
